import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { objOf } from 'ramda';
import { compose, withHandlers, withProps, defaultProps } from 'recompose';

import connect from 'app/libs/connect';
import CallToAction from 'app/components/layout/CallToAction.styled';
import LocalizedLink from 'app/features/localization/components/LocalizedLink/LocalizedLink';
import S from 'app/features/landing/productComparison/components/Product/Cta/SkipFreeTrialCta.styled';
import { checkoutUrlByPropsProduct } from 'app/features/checkout/selectors';
import { isProductWithOnePlan } from 'app/features/products/selectors';
import { userFlow } from 'app/features/user/selectors';
import { skipFreeTrialClicked } from 'app/features/landing/actions';
import { REGISTER_PATH, BILLING_PATH } from 'app/router/constants/paths';
import { ANONYMOUS } from 'app/features/user/constants/userFlow';

const UI = ({ to, textKey, onClick }) => (
  <S.SkipFreeTrial as={LocalizedLink} to={to} onClick={onClick}>
    <S.SkipFreeTrialCta
      as={CallToAction}
      size="s"
      data-t="skip-free-trial-button"
    >
      <FormattedMessage id={textKey} />
    </S.SkipFreeTrialCta>
  </S.SkipFreeTrial>
);

UI.propTypes = {
  textKey: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

UI.displayName = 'SkipFreeTrialCta';

const selectLink = ({
  userFlow,
  checkoutUrlByPropsProduct,
  isProductWithOnePlan,
}) => {
  if (userFlow === ANONYMOUS) {
    return REGISTER_PATH;
  }

  return isProductWithOnePlan ? checkoutUrlByPropsProduct : BILLING_PATH;
};

const handleClick = props => () => props.skipFreeTrialClicked(props);

const state = {
  userFlow,
  isProductWithOnePlan,
  checkoutUrlByPropsProduct,
};

const actions = { skipFreeTrialClicked };

const SkipFreeTrialCta = compose(
  defaultProps({ textKey: 'buttons_skip_free_trial' }),
  connect(state, actions),
  withProps(compose(objOf('to'), selectLink)),
  withHandlers({ onClick: handleClick }),
)(UI);

export { UI, handleClick, selectLink };

export default SkipFreeTrialCta;
